<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
 document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector(".custom-delivery-text-box")){
       const dhtml = document.querySelector(".custom-delivery-text-box").cloneNode(true);
      document.querySelector(".custom-delivery-text-box").remove();
      document.querySelector("product-form.productView-form.product-form").prepend(dhtml);
    }
   
    
    const collapsibleHeadings = document.querySelectorAll('.collapsible-heading');
    
    collapsibleHeadings.forEach(heading => {
      heading.addEventListener('click', function() {
        const parent = this.closest('.collapsible-item');
        const content = parent.querySelector('.collapsible-content');
        
        if (parent.classList.contains('is-open')) {
          parent.classList.remove('is-open');
          content.style.height = '0';
          content.style.padding = '0px 10px';
        } else {
          parent.classList.add('is-open');
          content.style.height = content.scrollHeight+20 + 'px';
          content.style.padding = '10px';
        }
      });
    });
  });